/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateWorkflowRequest } from '../model/createWorkflowRequest';
import { OrganisationLookupDto } from '../model/organisationLookupDto';
import { ShareAdminDto } from '../model/shareAdminDto';
import { UserLookupDto } from '../model/userLookupDto';
import { WorkflowDefinition } from '../model/workflowDefinition';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MyCheckShareControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param shareId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSharedMyCheckDraft(shareId: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public createSharedMyCheckDraft(shareId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public createSharedMyCheckDraft(shareId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public createSharedMyCheckDraft(shareId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling createSharedMyCheckDraft.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/shares/${encodeURIComponent(String(shareId))}/draft`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shareId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public discardSharedMyCheckDraft(shareId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public discardSharedMyCheckDraft(shareId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public discardSharedMyCheckDraft(shareId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public discardSharedMyCheckDraft(shareId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling discardSharedMyCheckDraft.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/workflows/definitions/shares/${encodeURIComponent(String(shareId))}/draft`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shareId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSharedMyCheckDefinition(shareId: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public getSharedMyCheckDefinition(shareId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public getSharedMyCheckDefinition(shareId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public getSharedMyCheckDefinition(shareId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling getSharedMyCheckDefinition.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('get',`${this.basePath}/workflows/definitions/shares/${encodeURIComponent(String(shareId))}/definition`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shareId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSharedMyCheckDraft(shareId: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public getSharedMyCheckDraft(shareId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public getSharedMyCheckDraft(shareId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public getSharedMyCheckDraft(shareId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling getSharedMyCheckDraft.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('get',`${this.basePath}/workflows/definitions/shares/${encodeURIComponent(String(shareId))}/draft`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listMyCheckShares(observe?: 'body', reportProgress?: boolean): Observable<Array<ShareAdminDto>>;
    public listMyCheckShares(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ShareAdminDto>>>;
    public listMyCheckShares(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ShareAdminDto>>>;
    public listMyCheckShares(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ShareAdminDto>>('get',`${this.basePath}/workflows/definitions/shares`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param query 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lookupShareOrganisations(query?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<OrganisationLookupDto>>;
    public lookupShareOrganisations(query?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrganisationLookupDto>>>;
    public lookupShareOrganisations(query?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrganisationLookupDto>>>;
    public lookupShareOrganisations(query?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', <any>query);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OrganisationLookupDto>>('get',`${this.basePath}/workflows/definitions/shares/lookup/organisations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param mail 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lookupShareUserByMail(mail: string, observe?: 'body', reportProgress?: boolean): Observable<UserLookupDto>;
    public lookupShareUserByMail(mail: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserLookupDto>>;
    public lookupShareUserByMail(mail: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserLookupDto>>;
    public lookupShareUserByMail(mail: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (mail === null || mail === undefined) {
            throw new Error('Required parameter mail was null or undefined when calling lookupShareUserByMail.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mail !== undefined && mail !== null) {
            queryParameters = queryParameters.set('mail', <any>mail);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserLookupDto>('get',`${this.basePath}/workflows/definitions/shares/lookup/users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param shareId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSharedMyCheckDraft(body: CreateWorkflowRequest, shareId: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public updateSharedMyCheckDraft(body: CreateWorkflowRequest, shareId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public updateSharedMyCheckDraft(body: CreateWorkflowRequest, shareId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public updateSharedMyCheckDraft(body: CreateWorkflowRequest, shareId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateSharedMyCheckDraft.');
        }

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling updateSharedMyCheckDraft.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('put',`${this.basePath}/workflows/definitions/shares/${encodeURIComponent(String(shareId))}/draft`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
